import React from "react";

const emojiMap = {
  1: "😭", // Never
  2: "😬", // Rarely
  3: "😶", // Sometimes
  4: "🙂", // Often
  5: "😁", // Usually
  6: "😃", // Almost Always
  7: "🏅", // Gold Standard
};

export const RATING_GUIDE = [
  {
    label: "Never",
    desc: "Never displayed the behavior even when there were opportunities.",
    emoji: emojiMap[1],
    value: 1,
  },
  {
    label: "Rarely",
    desc: "Displayed the behavior in very few occurrence and/or to a very small extent.",
    emoji: emojiMap[2],
    value: 2,
  },
  {
    label: "Sometimes",
    desc: "Displayed the behavior from time to time and/or to a small extent.",
    emoji: emojiMap[3],
    value: 3,
  },
  {
    label: "Often",
    desc: "Displayed the behavior frequently and/or to a moderate extent.",
    emoji: emojiMap[4],
    value: 4,
  },
  {
    label: "Usually",
    desc: "Displayed the behavior in most interactions and/or to a large extent.",
    emoji: emojiMap[5],
    value: 5,
  },
  {
    label: "Almost Always",
    desc: "Displayed the behavior to a very large extent.",
    emoji: emojiMap[6],
    value: 6,
  },
  {
    label: "Gold Standard",
    desc: "Displayed role model behavior consistently, every time, whatever the circumstance.",
    emoji: emojiMap[7],
    value: 7,
  },
];

export const RatingGuide = () => {
  return (
    <aside className="w-full md:w-80 md:sticky md:top-24 border rounded-md p-4 h-fit">
      <h4 className="font-semibold mb-4">Rating Guide</h4>
      <div className="space-y-4 text-sm">
        {RATING_GUIDE.map((g) => (
          <div key={g.label} className="space-y-1">
            <div className="font-medium">{g.emoji} {g.label}</div>
            <div className="text-muted-foreground">{g.desc}</div>
          </div>
        ))}
      </div>
    </aside>
  );
};
